const routes = module.exports = require('next-routes')()

routes
    .add('index', '/', 'index')
    .add('latest', '/latest/:tf?/:page?', 'videos/latest')
    .add('top-rated', '/top-rated/:tf?/:page?', 'videos/top-rated')
    .add('most-viewed', '/most-viewed/:tf?/:page?', 'videos/most-viewed')

    .add('categories', '/categories/:sort?/:page?', 'categories')
    .add('category', '/category/:cat_slug/:sort?/:page?', 'category')

    .add('models', '/models/:char([a-z])?/:sort?/:page?', 'models')
    .add('model', '/model/:slug/:page?', 'model')

    .add('livecams', '/livecams/:page?', 'livecams')

    .add('search', '/search/:query?/:min(\\d+)?/:max(\\d+)?/:sort?/:page?', 'search')
    .add('video', '/videos/:video_id(\\d+)/:title', 'video-view')

    .add('dmca', '/dmca.html', 'static/dmca')
    .add('terms', '/terms.html', 'static/terms')



// WEBPACK FOOTER //
// routes.js